import useTranslation from 'next-translate/useTranslation'
import * as T from 'components/ui/typography'
import * as React from 'react'
import { cn } from 'lib/utils'

const LabelBarChart = (props: PropsLabelBarChart) => {
    const { t } = useTranslation('common')

    const fill = React.useCallback((color: string) => `text-${color}`, [])

    return (
        <div className="flex flex-col items-center  justify-evenly flex-1">
            <T.P className="text-center ">{props.v.value.toString()}</T.P>
            <div className="flex justify-between gap-2 items-center">
                <T.Small className={cn(`!text-lg text-warning `, fill(props.v.fill))}>•</T.Small>
                <T.Small className="p-px capitalize mt-0 whitespace-nowrap  text-neutral-400">
                    {t(`${props.v.label}`)}
                </T.Small>
            </div>
        </div>
    )
}
export default LabelBarChart
